import { Search } from '@mui/icons-material';
import styled from 'styled-components'
import theme from '../../theme/theme';

export const SearchBarContainer = styled.div<{ width?: string }>`
    display: flex;
    flex-direction: row;
    position: relative;
    width: ${props => props.width ? props.width : '80%'};
    margin: 1rem auto;
`;

export const SearchBarInput = styled.input`
    width: 100%;
    height: 40px;
    padding: 0 1.75rem;
    border-radius: 50px;
    box-shadow: 0px 4px 4px 0px #00000040;
    border-color: #13314D;
    outline: none;
    font-size: 16px;
    color: #000000;
    font-weight: 500;

    &::placeholder {
        opacity: 0.6;
        transition: opacity 0.2s ease-in-out;
    }
    
    &:focus {
        &::placeholder {
          opacity: 0;
        }
    }
`;

export const SearchButtonContainer = styled.div`
    display: flex;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50px;
    background-color: ${theme.color.navy};
    &:hover {
        cursor: pointer;
        background-color: ${theme.color.silver};
        // background-color: #596875;
    }

    position: absolute;
    right: 0;
    margin-top: 6px;
    margin-right: 7px;
`;

export const SearchButton = styled(Search)`
    margin: auto;
    font-size: 20px !important;
    color: white;
`;

export const SearchBarContainerWrapper = styled.div`
  width: 300px; 
  position: relative;
`;